import { render, staticRenderFns } from "./provider-details.vue?vue&type=template&id=6b40f326"
import script from "./provider-details.vue?vue&type=script&lang=js"
export * from "./provider-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports